export default "__VITE_ASSET__CNdmrYNd__"